import { Feedback, FeedbackContentType } from 'v2/core/entities/feedback';

export const isFeedbackSummarySupported = (feedback: Feedback): boolean => {
  switch (feedback.content.type) {
    case FeedbackContentType.Audio:
      return false;
    default:
      return true;
  }
};
